import type { UserRecord } from "../api/client";
let currentUser: UserRecord | null = null;
export const session = {
  get hasHint(): boolean {
    return sessionStorage.getItem("authenticated") === "1";
  },
  get user(): UserRecord | null {
    return currentUser;
  },
  set(user: UserRecord): void {
    currentUser = user;
    sessionStorage.setItem("authenticated", "1");
    window.dispatchEvent(new Event("sessionchange"));
  },
  clear(): void {
    currentUser = null;
    sessionStorage.removeItem("authenticated");
    sessionStorage.removeItem("apiKey");
    window.dispatchEvent(new Event("sessionchange"));
  },
};
